function fn_comp_contact() {

    var $fn = $(".comp_contact");

    if ($fn.length) {
        var $gallery = $fn.find(".elm_gallery");
        if ($gallery.length){
            $gallery.lightGallery({
                thumbnail: true,
                selector: '.item',
            });
        }
    }
}